import React, {useEffect, useState} from "react";
import {Draggable, Droppable} from "react-beautiful-dnd";
import DragDropIcon from "../../images/drag_drop.svg";
import {
    ASCII_CODE_A,
    CHARACTERS_REMAINING,
    CHARACTERS_TEXT, DELETE_OPT_BTN,
    DRAG_TITLE, ENTER_PREMISE_TEXT,
    LATEX_REG_EXP,
    MC_ANSWER_LENGTH,
    PREMISE, QUESTION_TITLE_CHARACTER_LIMIT, TOGGLE_MENU_BAR_TEXT,
} from "../../utils/constants";
import {stripHTMLTags} from "../../utils/helpers";
import "../styles.css";
import {ReactComponent as TOGGLE} from "../../images/font_gray.svg";
import {ReactComponent as DRAG} from "../../images/drag_flat_grey.svg";
import {convertMHOptionMap} from "../../utils/questionUtils";
import {useCheckMainContainerNarrow} from "../../hooks/useCheckMainContainerNarrow";
import {EditorContent, useEditor} from "@tiptap/react";
import Underline from "@tiptap/extension-underline";
import StarterKit from "@tiptap/starter-kit";
import Placeholder from "@tiptap/extension-placeholder";
import CharacterCount from "@tiptap/extension-character-count";
import {menuBarExpandedStyle, TipTapMenuBar} from "../../components/Tiptap/TipTapMenuBar";
import TiptapClasses from "../../components/Tiptap/Tiptap.module.css";
import {Color} from "@tiptap/extension-color";
import TextStyle from "@tiptap/extension-text-style";
import Highlight from "@tiptap/extension-highlight";
import {YuJaTooltip} from "../../components/standardization/YuJaTooltip";
import classes from "../questions.module.css";
import {TipTapMenuBarNew} from "../../components/Tiptap/TipTapMenuBarNew";

export default function PremiseNew({
                                       optionData,
                                       selectedQuestion,
                                       questions,
                                       setQuestions,
                                       index,
                                       questionBuilder = false,
                                       disabled = false,
                                       collapsed,
                                       setCollapsed,
                                   }) {
    const {serialNo,} = selectedQuestion;
    const selectedQuestionIndex = serialNo - 1;

    const handleAnswerChange = (input, index) => {
        let copyOfQuestions = JSON.parse(JSON.stringify(questions));
        let newCorrectAnswers = copyOfQuestions[selectedQuestionIndex].correctAnswers;
        newCorrectAnswers[index][0] = input;
        if (!!questionBuilder) {
            copyOfQuestions[selectedQuestionIndex].optionsMap = convertMHOptionMap(newCorrectAnswers);
        }
        setQuestions(copyOfQuestions);
    };


    const editor = useEditor({
        shouldRerenderOnTransaction: true,
        editorProps: {
            transformPastedHTML(text) {
                return stripHTMLTags(text);
            },
        },
        extensions: [
            Underline,
            StarterKit,
            Placeholder.configure({
                placeholder: ENTER_PREMISE_TEXT + " " + (index + 1),
            }),
            CharacterCount.configure({limit: MC_ANSWER_LENGTH}),
            TextStyle,
            Color,
            Highlight,
            // Mathematics.configure({
            //   regex: LATEX_REG_EXP,
            // }),
        ],
        onUpdate: ({editor}) => {
            handleAnswerChange(editor.getHTML(), index);
        },
        content: !!optionData && !!optionData[0] ? optionData[0] : "",
    }, [serialNo]);

    useEffect(() => {
        if (!!optionData && optionData[0] !== editor.getHTML()) {
            editor.commands.setContent(optionData[0]);
        }

    }, [optionData, editor]);


    const renderIndexAndImage = (dragHandleProps) => {
        return (
            <>
                <span {...dragHandleProps} style={{marginLeft: 12}}>
                    <DRAG/>
                </span>
                <span className={`${classes.optionIndex}`}>
                    {index + 1}
                </span>
            </>
        );
    }


    const renderOptionManageBar = () => {
        return (
            <div style={{display: "flex", gap: 5, alignItems: "center", paddingRight: 12}}>
                <span
                    tabIndex={0}
                    style={{cursor: "pointer",}}
                    title={TOGGLE_MENU_BAR_TEXT}
                    onClick={() => setCollapsed(!collapsed)}
                >
                    <TOGGLE/>
                </span>
            </div>
        );
    }


    if (!optionData || optionData.length < 2) {
        return <div className={classes.MHLeftContainer}></div>
    }


    return (
        <Droppable droppableId={"premise_" + index}>
            {(provided, snapshot) => (
                <div
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                    {...provided.dropHandleProps}
                    className={classes.MHLeftContainer}
                    style={{display: "unset"}}
                >
                    <Draggable
                        draggableId={"premise draggable " + index}
                        index={index}
                        isDragDisabled={questionBuilder && disabled}
                    >
                        {(provided) => (
                            <div
                                tabIndex={-1}
                                className={classes.optionBarWrapper}
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                            >
                                <div className={classes.optionBar}>
                                    {!!collapsed && renderIndexAndImage(provided.dragHandleProps)}
                                    <span className={classes.optionEditorWrapper}>
                                        <div className={`${classes.optionEditorMenuBar} ${collapsed ? classes.collapsed : ""}`}>
                                            <TipTapMenuBarNew
                                                isOpen={!collapsed}
                                                editor={editor}
                                                selectedQuestion={selectedQuestion}
                                            />
                                            {!collapsed && renderOptionManageBar()}
                                        </div>
                                        <div style={{display: "flex", gap: 10, alignItems: "center"}}>
                                            {!collapsed && renderIndexAndImage(provided.dragHandleProps)}
                                            <EditorContent
                                                editor={editor}
                                                style={{cursor: "text", flex: 1, minWidth: 0, height: "100%", paddingRight: collapsed ? 10 : undefined}}
                                                className={`${TiptapClasses.editorContentBox} ${collapsed ? TiptapClasses.noneOutLine : ""}`}
                                            />
                                        </div>


                                        {(!collapsed || (!!editor.isFocused && editor.storage.characterCount.characters() > 0)) &&
                                            <span className={`${classes.characterCountBox} ${collapsed ? classes.inline : ""}`}>
                                                {collapsed
                                                    ? editor.storage.characterCount.characters()
                                                    : `${editor.storage.characterCount.characters()}/${MC_ANSWER_LENGTH}`
                                                }
                                            </span>
                                        }
                                    </span>
                                    {!!collapsed && renderOptionManageBar()}
                                </div>
                            </div>
                        )}
                    </Draggable>
                    {provided.placeholder}
                </div>
            )}
        </Droppable>
    );
}